module.exports = __webpack_public_path__ + "static/img/engb5.6755431.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/eng/engb5.png
// module id = trZw
// module chunks = 0